import React from 'react'
import { Box, Icon, Typography } from '@astro-ui/components'
import * as S from '../../DatePickerStyled'

export type FieldsetPropsType = {
  date: string
  placeholder: string
  disabled?: boolean
  customIcon?: React.ReactNode
  isError?: boolean
  handleOpen: (event: React.MouseEvent<HTMLDivElement>) => void
}

function Fieldset({
  date,
  placeholder,
  disabled,
  customIcon,
  isError = false,
  handleOpen,
}: FieldsetPropsType) {
  return (
    <S.Fieldset
      className="fieldset-datepicker"
      onClick={handleOpen}
      disabled={disabled}
      isError={isError}
    >
      <Box display="flex" alignItems="center">
        {customIcon || <Icon icon="calendar" color="black" />}
        <Typography variant="body2" color={date ? 'black' : '#ccc'} ml="8px">
          {date || placeholder}
        </Typography>
      </Box>
      <S.IconExpand>
        {/* eslint-disable react/no-unknown-property */}
        <svg
          className="MuiSvgIcon-root-ffbdHq fAvwPm MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSelect-icon-fwbJUW vchSV MuiSelect-icon MuiSelect-iconStandard"
          focusable="false"
          aria-hidden="true"
          viewBox="0 0 24 24"
          data-testid="ArrowDropDownIcon"
        >
          <path d="M7 10l5 5 5-5z" />
        </svg>
      </S.IconExpand>
    </S.Fieldset>
  )
}

export default Fieldset
